import { render, staticRenderFns } from "./Postit.vue?vue&type=template&id=669ff226&scoped=true&"
import script from "./Postit.vue?vue&type=script&lang=js&"
export * from "./Postit.vue?vue&type=script&lang=js&"
import style0 from "./Postit.vue?vue&type=style&index=0&id=669ff226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669ff226",
  null
  
)

component.options.__file = "Postit.vue"
export default component.exports